import * as React from "react"
import { connect } from "react-redux"

import {
    InlineAttachment,
    ToolboxAttachments,
} from "@tenforce/toolbox-attachments-react"

import { GlobalState } from "../../../store"
import { Labels } from "../../../util/Translations"

import { DispatchProps, mapDispatchToProps } from "../actions"
import {
    AttachmentField,
    getCustomFieldAttachments,
    getDetailPageAttachmentField,
} from "../selectors"

export interface OwnProps {
    canAddAttachments: boolean
    canDeleteAttachments: boolean
    customFieldDefinitionId: string
    customFieldName: string
    isPrintView: boolean
    itemId: number
}

interface StateProps extends AttachmentField {
    attachmentsWithoutPagination: ToolboxAttachments.Attachment[]
}

type Props = OwnProps & StateProps & DispatchProps

export class DetailPageInlineAttachment extends React.PureComponent<Props> {
    componentDidMount(): void {
        this.requestAttachments()
    }

    render(): JSX.Element {
        const {
            canAddAttachments,
            canDeleteAttachments,
            customFieldName,
            showAllDocuments,
            isPrintView,
            attachmentLoadCounter,
            attachmentsWithoutPagination,
        } = this.props

        const canEditAttachments = !isPrintView && canDeleteAttachments

        return (
            <InlineAttachment
                cardWrapperClasses="tw-p-2 tw-w-full sm:tw-w-1/2 md:tw-w-1/3 lg:tw-w-1/6"
                attachmentsPrivs={{
                    canAdd: !isPrintView && canAddAttachments,
                    canDelete: canEditAttachments,
                    canEditDescription: canEditAttachments,
                    canDownload: true,
                }}
                fieldName={customFieldName}
                maxInitialCards={18}
                attachmentsActions={{
                    loadCounter: attachmentLoadCounter,
                    shouldShowAll: showAllDocuments || isPrintView,
                    onDelete: this.onDeleteAttachment,
                    onAdd: this.onAddAttachment,
                    onLoadMore: this.loadMoreAttachments,
                    onLoad: this.onAttachmentLoad,
                    onUpdateDescription: this.onUpdateAttachmentDescription,
                }}
                attachments={attachmentsWithoutPagination}
                labels={{
                    openImageInNewTab: Labels.OpenImageInANewTab,
                    addDescriptionHere: Labels.AddDescriptionHere,
                    browseDropFilesHere: Labels.BrowseDropFilesHere,
                    deleteThisAttachment: Labels.Delete,
                    dropItAs: Labels.DropItAs,
                    loadNMore: Labels.LoadNMore,
                }}
            />
        )
    }

    onAddAttachment = async (request: UploadRequest): Promise<void> => {
        const { customFieldDefinitionId, itemId, requestAddAttachment } =
            this.props
        const formData = new FormData()
        formData.append(request.filename, request.file)
        requestAddAttachment(itemId, customFieldDefinitionId, formData)
    }

    onDeleteAttachment = async (attachmentId: number): Promise<void> => {
        const { customFieldDefinitionId, itemId, requestDeleteAttachment } =
            this.props

        const { DeleteThisAttachment } = Labels
        if (confirm(DeleteThisAttachment)) {
            requestDeleteAttachment(
                itemId,
                customFieldDefinitionId,
                attachmentId,
            )
        }
    }

    onUpdateAttachmentDescription = async (
        key: number,
        value: string,
    ): Promise<void> => {
        const { itemId, customFieldDefinitionId, updateAttachmentDescription } =
            this.props

        updateAttachmentDescription(key, value, itemId, customFieldDefinitionId)
    }

    requestAttachments = (): void => {
        const { customFieldDefinitionId, itemId, requestAttachments } =
            this.props
        requestAttachments(itemId, customFieldDefinitionId)
    }

    loadMoreAttachments = (): void => {
        const { customFieldDefinitionId, loadMoreAttachments } = this.props
        loadMoreAttachments(customFieldDefinitionId)
    }

    onAttachmentLoad = (): void => {
        const { customFieldDefinitionId, attachmentLoaded } = this.props
        attachmentLoaded(customFieldDefinitionId)
    }
}

const mapStateToProps = (state: GlobalState, props: OwnProps): StateProps => ({
    ...state.inlineAttachments,
    ...getDetailPageAttachmentField(state.inlineAttachments, props),
    attachmentsWithoutPagination: getCustomFieldAttachments(
        state.inlineAttachments,
        props,
    ),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DetailPageInlineAttachment)
